module.exports = __webpack_public_path__ + "static/media/vvs_prez.93769e46.jpg";